// extracted by mini-css-extract-plugin
export default {"container":"switch_container__ixqcv","option":"switch_option__HpzuL","option--active":"switch_option--active__6CpDX"};